import ListView from "@ckeditor/ckeditor5-ui/src/list/listview"

export default class SelectView extends ListView {
  constructor() {
    super()
    const bind = this.bindTemplate
    arguments
    this.decorate("initFirst")

    this.set({ value: {} })

    this.setTemplate({
      tag: "select",

      attributes: {
        class: ["ck", "ck-reset", "ck-list"],
      },
      on: {
        change: bind.to((evt) => {
          const element = evt.target.selectedOptions[0]
          this.value = {
            id: this.getInlineAdvertisementIdFrom(element),
            description: this.getInlineAdvertisementDescriptionFrom(element),
          }
        }),
      },

      children: this.items,
    })
  }
  initFirst() {
    const element = this.items.first.element
    this.value = {
      id: this.getInlineAdvertisementIdFrom(element),
      description: this.getInlineAdvertisementDescriptionFrom(element),
    }
  }
  getInlineAdvertisementIdFrom(element) {
    return parseInt(
      element.children[0].getAttribute("inline-advertisement-id"),
      10
    )
  }
  getInlineAdvertisementDescriptionFrom(element) {
    return element.children[0].getAttribute("inline-advertisement-description")
  }
}
